module.exports = __webpack_public_path__ + "img/compras_publicas_bronze.17075a59.png";